import { render, staticRenderFns } from "./PoiSheet.vue?vue&type=template&id=a634b3fc&scoped=true&"
import script from "./PoiSheet.vue?vue&type=script&lang=js&"
export * from "./PoiSheet.vue?vue&type=script&lang=js&"
import style0 from "./PoiSheet.vue?vue&type=style&index=0&id=a634b3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a634b3fc",
  null
  
)

export default component.exports